import { Comment } from "component/comment";
import { ModuleMap, ModuleMapMap, defineModuleGlobal, defineModuleMap, defineModuleMapMap } from "util/moduledata";
import { Persona } from "util/stdtypes";


export type ModTask = {
    key: string; 
    // "id" is a human-readable identifier and visible in the Mod Dashboard for easier identification of mod tasks, e.g. ZDF-COMMENT-1
    id?: string;
    text: string | null;
    structureKey: string;
    instanceKey: string;
    appealText?: string | null;
    time: number;
    objectTime?: number;
    type: ModTaskType;
    source?: FlagSource;
    violates?: boolean;
    violations?: string;
    judgement?: JudgementType;
    humanJudgement?: boolean;
    judgeKey?: string;
    judgementTime?: number;
    reasoning?: string;
    object?: Comment;
    // Note: Whether we want to keep mod tasks of desleted comments or delete them is still up for discussion. We might need to keep them if a user's comment has legal repercussions.
    deleted?: boolean; // DEPRECATED. Just delete the object instead
};

export type ModAuthor = {
    authorHue: number;
    authorKey: string;
    authorMemberSince: number;
    authorName: string;
    authorPhoto: string;
    from: string;
};

export enum ModTaskType {
    COMMENT = "comment",
    TOPIC = "topic"
}

export enum FlagSource {
    REPORT = "report",
    PRE_MODERATION = "premoderation"
}

export enum JudgementType {
    REJECT = "reject",
    ACCEPT = "approve"
}

export type Suspension = {
    isBlocked: boolean;
}

export type Bookmark = {
    key: string;
    instanceKey: string;
    time: number;
    type: ModTaskType;
    isBookmarked: boolean;
}

export type ModeratorNotesSummary = {
    amount: number;
}

export type TaskWatchState = {
    modID: string;
    sessionId: string;
    time: number;
    name: string;
    photoUrl: string | null;
    hue: number | null;
}

export type ModerationUser = {
    timeLastModerationAction: number;
}


export const moduleMapQueue: ModuleMap<ModTask> = defineModuleMap<ModTask>("PUBLIC", "moderation", "queue");

export const moduleMapQueueCount: ModuleMap<number> = defineModuleMap('PUBLIC', 'moderation', 'count_queue_filtered');

export const moduleMapMapFilteredQueue : ModuleMapMap<ModTask> = defineModuleMapMap('PUBLIC', 'moderation', 'queue_filtered');

export const moduleMapSuspension = defineModuleMap<Suspension>('PUBLIC', 'moderation', 'suspension');

export const moduleGlobalLastUpdate = defineModuleGlobal<number>('PUBLIC', 'moderation', 'lastUpdate');

export const moduleGlobalBlocklistLastUpdate = defineModuleGlobal<number>('PUBLIC', 'blocklist', 'lastUpdate');
 
// FIXME (Rob): This should use a valid module name, not bookmarks_count
export const moduleGlobalBookmarksCount = defineModuleGlobal<number>('USER_GLOBAL', 'bookmarks_count', 'bookmarkCount');

export const moduleMapBookmarks = defineModuleMap<Bookmark>('USER_GLOBAL', 'bookmarks', null);

export const moduleMapNotesSummary = defineModuleMap<ModeratorNotesSummary>('PUBLIC', 'moderation', 'moderatorNotes');

export const moduleMapModerator : ModuleMap<Persona> = defineModuleMap("PUBLIC", 'moderation', 'moderator');

export const moduleMapSortOrder = defineModuleMap<string>('USER_GLOBAL', 'moderation', 'sortOrder');

export const moduleMapTaskWatchState = defineModuleMap<TaskWatchState>('PUBLIC', 'moderation', 'taskWatchState');

export const moduleMapModerationUser = defineModuleMap<ModerationUser>('PUBLIC', 'moderation', 'user');